import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/home';
import EagleTracker from './pages/eagle-tracker';
import EagleTrackerScoreBug from './pages/eagle-tracker-score-bug';
import FanTentPage from './pages/fan-tent';
import TheGrovePage from './pages/the-grove';
import MSOfficePage from './pages/ms-offices';
import Hospitality17Page from './pages/hospitality-17';
import Hospitality17PortraitPage from './pages/hospitality-17-portrait';
import Hospitality18Page from './pages/hospitality-18';
import TestPage from './pages/test-page';

import { useEagleCountSubscription, useFetchEagleCount } from './hooks';
import './fonts/fonts.css';

function App() {
  const initialEagleCount = useFetchEagleCount(
    `${process.env.REACT_APP_EAGLE_COUNTER_URL}/api/getEagleCount`
  );
  const { eagleCount, prevEagleCount } = useEagleCountSubscription(
    `${process.env.REACT_APP_EAGLE_COUNTER_URL}/api/getPubSubClientAccessUrl`,
    initialEagleCount
  );

  return (
    <Routes>
      <Route path="/" element={ <HomePage /> } />

      <Route path="/eagle-tracker" element={
        <EagleTracker
          eagleCount={eagleCount}
          prevEagleCount={prevEagleCount}
        />
      } />
      
      <Route path="/score-bug" element={
        <EagleTrackerScoreBug 
          eagleCount={eagleCount} 
        />
      } />

      <Route path="/fan-tent" element={
        <FanTentPage />
      } />

      <Route path="/the-grove" element={
        <TheGrovePage 
          eagleCount={eagleCount} 
          prevEagleCount={prevEagleCount}
        />
      } />

      <Route path="/hospitality-17" element={
        <Hospitality17Page
          eagleCount={eagleCount}
          prevEagleCount={prevEagleCount}
        />
      } />
      
      <Route path="/hospitality-17-portrait" element={
        <Hospitality17PortraitPage
          eagleCount={eagleCount}
          prevEagleCount={prevEagleCount}
        />
      } />

      <Route path="/hospitality-18" element={
        <Hospitality18Page
          eagleCount={eagleCount}
          prevEagleCount={prevEagleCount}
        />
      } />

      <Route path="/ms-offices" element={
        <MSOfficePage 
          eagleCount={eagleCount} 
        />
      } />

      <Route path="/test-page" element={
        <TestPage
          eagleCount={eagleCount}
          prevEagleCount={prevEagleCount}
        />
      } />
    </Routes>
  );
}

export default App;
